/**
 * TextField: one labelled input with its tip and its hint, the shape every
 * text field on the staff team configuration pages takes. The tip says
 * what the field is; the hint is a line under the field.
 */

import { FieldLabel } from '@/components/shared/InfoTip'
import { Input } from '@/components/ui/input'
import { describedBy, tipId } from '@/lib/describedBy'

interface TextFieldProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  tip?: string
  hint?: string
  mono?: boolean
  disabled?: boolean
  type?: 'text' | 'number' | 'password'
}

export function TextField({
  id,
  label,
  value,
  onChange,
  placeholder,
  tip,
  hint,
  mono = false,
  disabled = false,
  type = 'text',
}: TextFieldProps): React.JSX.Element {
  const hintId = `${id}-hint`
  return (
    <div className="space-y-2">
      <FieldLabel htmlFor={id} label={label} tip={tip} />
      <Input
        id={id}
        type={type}
        className={mono ? 'font-mono' : undefined}
        value={value}
        autoComplete="off"
        disabled={disabled}
        placeholder={placeholder}
        aria-describedby={describedBy(tip !== undefined && tipId(id), hint !== undefined && hintId)}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      />
      {hint !== undefined && (
        <p id={hintId} className="text-xs text-muted-foreground">
          {hint}
        </p>
      )}
    </div>
  )
}
